import { ID, ReduxAction } from '@app/types';
import { ActivityItem } from '@models/Activity';
import { AppState } from '@reducers/rootReducer';
import { Map } from 'immutable';

export type ExpandableActivityItemsState = Map<ID, ActivityItem>;
const initialExpandableActivityItemsState = Map<ID, ActivityItem>();

export const selectExpandableActivityItem = (id: ID) => (state: AppState) =>
  state.data.expandableActivityItems.get(id);

const isExpandable = (item: any) =>
  !!item &&
  ((item?.itemType === 'post' && item.metadata?.postSubtype !== 'announcement') ||
    item?.metadata?.subtype === 'bio');

const addExpandableItems = (
  state: ExpandableActivityItemsState,
  items: any[],
): ExpandableActivityItemsState =>
  state.merge(
    Map(items.filter(isExpandable).map((item) => [String(item.id), new ActivityItem(item)])),
  );

export function expandableActivityItemsReducer(
  state: ExpandableActivityItemsState = initialExpandableActivityItemsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_HIGHLIGHTS_SUCCEEDED':
      return addExpandableItems(state, payload.response);

    case 'FETCH_ALL_ACTIVITY_SUCCEEDED':
    case 'FETCH_GROUP_ACTIVITY_SUCCEEDED':
      return addExpandableItems(state, payload.response.results);

    default:
      return state;
  }
}
